import { render, staticRenderFns } from "./TabShow.vue?vue&type=template&id=3206e157&scoped=true&"
import script from "./TabShow.vue?vue&type=script&lang=coffee&"
export * from "./TabShow.vue?vue&type=script&lang=coffee&"
import style0 from "./TabShow.vue?vue&type=style&index=0&id=3206e157&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3206e157",
  null
  
)

export default component.exports